import { render, staticRenderFns } from "./Gravacaoteste.vue?vue&type=template&id=260b7c29&"
import script from "./Gravacaoteste.vue?vue&type=script&lang=js&"
export * from "./Gravacaoteste.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports